/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_03_CategoryInputs */

const en_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const ar_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم`)
};

const bn_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিজাইন`)
};

const de_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const es_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño`)
};

const fr_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception`)
};

const pt_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto`)
};

const zh_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设计`)
};

const tr_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasarım`)
};

const ru_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизайн`)
};

const pl_elastic_gallery_item_03_category = /** @type {(inputs: Elastic_Gallery_Item_03_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt`)
};

/**
* | output |
* | --- |
* | "Design" |
*
* @param {Elastic_Gallery_Item_03_CategoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_03_category = /** @type {((inputs?: Elastic_Gallery_Item_03_CategoryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_03_CategoryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_03_category(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_03_category(inputs)
	if (locale === "de") return de_elastic_gallery_item_03_category(inputs)
	if (locale === "es") return es_elastic_gallery_item_03_category(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_03_category(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_03_category(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_03_category(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_03_category(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_03_category(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_03_category(inputs)
	return en_elastic_gallery_item_03_category(inputs)
});